<script>
import lazyLoadComponent from '@router/lazyload-component'
import productMixin from '@/src/mixins/product'
import Layout from '@layouts/main'

export default {
  page: {
    title: '數據分析',
    meta: [
      { name: 'description', container: 'Data Analytics' },
      {
        name: 'google-signin-scope',
        content: 'https://www.googleapis.com/auth/analytics.readonly',
      },
    ],
  },
  components: {
    ScheduleStaffDetail: () => lazyLoadComponent(import('@components/ScheduleStaff/ScheduleStaffDetail')),
    Layout,
  },
  mixins: [productMixin],
  props: {
    staffItems: {
      type: Array,
      required: true,
    },
    merchantProducts: {
      type: Array,
      required: true,
    },
    /**
     * @description 從分店打過來的狀況
     */
    userActiveTab: {
      type: String,
      default: 'prices'
    },
    userActiveId: {
      type: String,
      default: ''
    },
    userRecords: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      activeTab: 'prices',
      formattedJson: '',
      sellShow: false,
      tabList: [
        {
          title: '美容服務排班分店',
          component: () => lazyLoadComponent(import('@/src/router/views/schedule/index-new')),
          type: 'prices',
          isSpace: false,
          fetchTypes: ['cosmetic'],
          name: 'prices',
          componentName: 'index-new'
        },
        {
          title: '人員管理',
          component: () => lazyLoadComponent(import('./TabList')),
          type: 'text',
          isSpace: false,
          fetchTypes: ['cosmetic'],
          name: 'peopleManage',
          componentName: 'TabList'
        },
      ],
      valueHome: '',
      locationService: '',
      locationDayCare: '',
      locationSpace: '',
      showSelectGroup: true, // 是否顯示蓋掉tab的按鈕
      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build',
    }
  },
  computed: {
    filterMerchantProducts() {
      return this.filterProductInMixin(JSON.parse(JSON.stringify(this.merchantProducts)))
    }
  },
  watch: {
    activeTab(nvl, ovl) {
      if (nvl === "peopleManage" || nvl === 'spaceManage') {
        this.sellShow = true
      }
    },
  },
  created() {

  },
  mounted() {
    this.initModuleTab()
    if (this.userActiveTab === 'peopleManage' || this.userActiveTab === 'spaceManage') {
      this.activeTab = this.userActiveTab
      setTimeout(() => {
        this.$refs['step2'][0].tryToFetchDetail(this.userActiveId)
      }, 500)
    }
  },
  methods: {
    /**
     * @description module Tab
     */
    initModuleTab() {
      if (this.$hasSpaceModule()) {
        this.tabList.splice(1, 0,
          {
            title: '空間服務排班分店',
            component: () => lazyLoadComponent(import('@/src/router/views/schedule/index-new')),
            type: 'space',
            isSpace: true,
            fetchTypes: ['space'],
            name: 'space',
            componentName: 'index-new'
          })
      }
      if (this.$hasSpaceModule()) {
        this.tabList.push({
          title: '空間管理',
          component: () => lazyLoadComponent(import('./TabList')),
          type: 'text',
          isSpace: true,
          fetchTypes: ['space'],
          name: 'spaceManage',
          componentName: 'TabList'

        })
      }
    },
    setLocationId(id) {
      this.locationService = id
    },
    /**
     * @description 讓上方tab消失/出現
     */
    showOffOuterTab({ displayType, pageType }) {
      for (let i = 0, len = this.$refs.outerTabs.$children[0].$refs.tabs.length; i < len; i++) {
        this.$refs.outerTabs.$children[0].$refs.tabs[i].style.display = displayType
      }
      this.showSelectGroup = displayType === 'none' ? false : true
    },
    /**
     * @description 看是不是切換tab or select
     */
    changeSelect(type, tabName) {
      try {
        // 如果選擇人員管理 or 空間管理 清掉選到的location
        if (tabName === 'peopleManage' || tabName === 'spaceManage') {
          this.locationService = ''
          this.locationSpace = ''
          this.locationDayCare = ''
        }
        // 如果點選到美容服務排班select
        if (tabName === 'prices') {
          this.locationDayCare = ''
          this.locationSpace = ''
          this.$refs.prices[0].tryToFetchFromFather(this.locationService)
        }
        // 如果點選到安親服務排班select
        if (tabName === 'daycare') {
          this.locationService = ''
          this.locationSpace = ''
        }
        // 如果點選到空間服務排班select
        if (tabName === 'space') {
          this.locationService = ''
          this.locationDayCare = ''
        }

      } catch (error) {
        console.error(error.message)
      }
    },
    focusSelect(type) {
      this.activeTab = type
      if (type === "prices") {
        this.$nextTick(() => {
          this.$refs.prices[0].tryToFetchFromFather(this.locationService)
        })
      }
      if (type === "space") {
        this.$nextTick(() => {
          this.$refs.space[0].tryToFetchFromFather(this.locationService)
        })
      }
    }
  }
}
</script>

<template>
  <Layout>
    <div>
      <el-tabs ref="outerTabs" v-model="activeTab" stretch type="border-card" class="isStyleBase" :class="$style.tabsStyle"
        >
        <el-tab-pane v-for="(tab, index) in tabList" :key="`pane${index}`" :label="tab.title" :name="`${tab.name}`">
          <el-select v-if="tab.type === 'prices'" slot="label" v-model="locationService"
            :class="[$style.productPlacement, activeTab === 'prices' ? $style.placeholderColorPrimaryColor : '']"
            class="is-no-tb-border" placeholder="美容服務排班分店" @change="changeSelect('service', 'prices')"
            @focus="focusSelect('prices')">
            <el-option v-for="(location, typeValue) in filterMerchantProducts" :key="typeValue"
              :label="`${location.name}排班`" :value="location.id"></el-option>
          </el-select>
          <el-select v-if="tab.type === 'space'" slot="label" v-model="locationSpace" 
            :class="[$style.productPlacement, activeTab === 'space' ? $style.placeholderColorPrimaryColor : '']"
            class="is-no-tb-border" placeholder="服務空間排程分店" @change="changeSelect('service', 'space')"
            @focus="focusSelect('space')">
            <el-option v-for="(location, typeValue) in filterMerchantProducts" :key="typeValue"
              :label="`${location.name}排班`" :value="location.id"></el-option>
          </el-select>
          <el-select v-if="tab.type === 'daycare'" slot="label" v-model="locationDayCare" 
            :class="[$style.productPlacement, activeTab === 'daycare' ? $style.placeholderColorPrimaryColor : '']"
             class="is-no-tb-border" placeholder="請選擇服務地點"
            @change="changeSelect('service', 'daycare')" @focus="focusSelect('daycare')">
            <el-option v-for="(location, typeValue) in filterMerchantProducts" :key="typeValue"
              :label="`${location.name}安親住宿`" :value="location.id"></el-option>
          </el-select>
        </el-tab-pane>
      </el-tabs>
      <div v-for="(tab, index) in tabList" :key="index" :class="$style.marginContent">
        <template v-if="tab.componentName === 'index-new'">
          <component :is="tab.component" v-show="activeTab === `${tab.name}`" :ref="`${tab.name}`"
            :merchant-products="filterMerchantProducts" :staff-items="staffItems" :sell-show="sellShow"
            :location-service="locationService" :is-space="tab.isSpace" :fetch-types="tab.fetchTypes" :user-records="userRecords"
            @showOffOuterTab="showOffOuterTab" @setLocationId="setLocationId">
          </component>
        </template>
        <template v-if="tab.componentName === 'TabList'">
          <component :is="tab.component" v-if="activeTab === `${tab.name}`" :ref="`${tab.name}`"
            :merchant-products="filterMerchantProducts" :staff-items="staffItems" :sell-show="sellShow"
            :location-service="locationService" :is-space="tab.isSpace" :fetch-types="tab.fetchTypes" :user-records="userRecords"
            @showOffOuterTab="showOffOuterTab" @setLocationId="setLocationId">
          </component>
        </template>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

.marginContent {
  margin: 20px;
}

:global {
  .isPage {
    .el-tabs__content {
      padding-bottom: 40px;
    }
  }
}

.tabsStyle {
  :global {
    .el-tabs__item:first-child {
      padding-left: 0;
    }

    .el-tabs__content {
      display: none;
    }

    .el-tab-pane {
      padding: 10px 20px 20px;
      background-color: $color-body-bg !important;
    }
  }
}

.selectGroup {
  display: flex;
  justify-content: flex-start;
  position: absolute;
  width: 100%;
  border: 0;

  :global {
    .el-select .el-input--suffix>.el-input__inner {
      background-color: $color-body-bg;
    }

    .el-input {
      height: 54px;
      position: relative;
      bottom: 1px;
    }

    .el-input__icon {
      color: #121931 !important;
    }

    .el-input__inner {
      height: $tabs-item--header-height;
      border-radius: 0;
      border: 0;
      font-size: 16px;
      text-align: center;

      &::placeholder {
        color: #868996;
        opacity: 1;
      }
    }

    .el-select .el-input.is-focus .el-input__inner {
      border-right: 1px solid #E5E7EB;
      color: $color-primary;

      &::placeholder {
        color: $color-primary;
        opacity: 1;
      }
    }
  }
}

.placeholderColorPrimaryColor {
  :global {
    .el-input--suffix>.el-input__inner {
      color: $color-primary !important;
    }
  }
}

.productPlacement {
  position: absolute;
  z-index: 100;
  left: 0;
  color: #888c98;

  :global {
    .el-input__inner {
      height: $tabs-item--header-height;
      border-radius: 0;
      border: 0;
      color: #888c98;
      font-size: 16px;
      text-align: center;

      &::placeholder {
        color: #888c98;
        opacity: 1;
      }
    }

    .el-input__icon {
      color: white;
    }
  }

  @include pad {
    top: 0;
  }

}
</style>
